import { createContext, useContext, type ReactNode } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import type { AppCollections } from "./create-app-collections";

const CollectionsContext = createContext<AppCollections | undefined>(undefined);

export function CollectionsProvider({
  collections,
  children,
}: {
  collections: AppCollections;
  children: ReactNode;
}) {
  return <CollectionsContext.Provider value={collections}>{children}</CollectionsContext.Provider>;
}

export function AppDbProvider({
  queryClient,
  collections,
  children,
}: {
  queryClient: QueryClient;
  collections: AppCollections;
  children: ReactNode;
}) {
  return (
    <QueryClientProvider client={queryClient}>
      <CollectionsProvider collections={collections}>{children}</CollectionsProvider>
    </QueryClientProvider>
  );
}

export function useAppCollections(): AppCollections {
  const collections = useContext(CollectionsContext);
  if (!collections) {
    throw new Error("No AppCollections in context. Wrap the tree in <CollectionsProvider>.");
  }
  return collections;
}
